import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/Edit.css';
import { updateAdvisor } from '../../utils/api';
import { fetchUserData } from '../../utils/api';
import { BIOBANK_ROUTES } from '../../constants/routes';
const EditAdvisor = () => {
  const [advisorName, setAdvisorName] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const loadCurrentAdvisor = async () => {
      try {
        const userData = await fetchUserData();
        if (userData.advisor && userData.advisor !== "Not Set") {
          setAdvisorName(userData.advisor.trim());
        }
      } catch (error) {
        console.error('Error loading current advisor:', error);
      }
    };
    loadCurrentAdvisor();
  }, []);

  const handleAdvisorChange = (e) => {
    setAdvisorName(e.target.value);
    setError('');
  };

  const handleSave = async (e) => {
    e.preventDefault();
    const trimmedAdvisor = advisorName.trim();

    const regex = /^[A-Za-z]+,\s*[A-Za-z]+$/;
    if (trimmedAdvisor && !regex.test(trimmedAdvisor)) {
      setError('Format must be "LastName, FirstName" using only letters.');
      return;
    }
    try {
      await updateAdvisor(trimmedAdvisor);
      navigate(BIOBANK_ROUTES.PROFILE);
    } catch (error) {
      console.error('Error saving advisor:', error.message);
      setError('Failed to update advisor. Please try again.');
    }
  };

  const handleCancel = () => {
    navigate(BIOBANK_ROUTES.PROFILE);
  };

  const handleClear = () => {
    setAdvisorName('');
    setError('');
  };

  return (
    <div className="edit-wrapper">
      <div className="edit-container">
        <div className="edit-header">
          <h2>Add Advisor</h2>
          <button className="close-btn" onClick={handleCancel}>X</button>
        </div>
        {error && <p className="error-message">{error}</p>}
        <form onSubmit={handleSave}>
          <div className="edit-content">
            <div className="phone-input-container">
              <label htmlFor="advisor">Last Name, First Name</label>
              <div className="input-with-clear">
                <input
                  id="advisor"
                  type="text"
                  value={advisorName}
                  onChange={handleAdvisorChange}
                  placeholder="Last Name, First Name"
                  className={error ? 'error-border' : ''}
                />
                {advisorName && (
                  <button 
                    type="button" 
                    className="clear-btn" 
                    onClick={handleClear}
                    title="Clear advisor"
                  >
                    ×
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="button-group">
            <button type="submit" className="save-btn">Save</button>
            <button type="button" className="cancel-btn" onClick={handleCancel}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditAdvisor;